export interface M<T> {
    readonly pattern: RegExp
    readonly constructor: (matches: string[]) => T
}

export function parsePath<T>(
    routeDefinitions: M<T>[],
    path: string
): T | null {
    for (const {pattern, constructor} of routeDefinitions) {
        const match = path.match(pattern)
        if (match !== null) {
            return constructor(match.slice(1))
        }
    }
    return null
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/RouteDefinition.ts